module.exports = __webpack_public_path__ + "img/group-map-terrain.3160a435.png";